const StateJS = require('@steelbreeze/state');
const EventEmitter = require('events').EventEmitter;
const Enum = require('./enums');
const Event = require('./events');

/*
 * Definition for type : Html5Video
 */

function Html5Video(name, root) {
  this.bus = (root === null) ? new EventEmitter() : root.bus;
  this.name = name;
  this.root = (root === null) ? this : root;
  this.ready = false;

  this.build(name);
}

Html5Video.prototype.build = function (session) {
  /* State machine (states and regions) */
  /* Building root component */
  this._statemachine = new StateJS.State('default_statemachine').entry(() => {
    // reset properties
    this.Html5Video_null_needsFullReset_var = this.isInternetExplorer();
  });
  const _initial_Html5Video = new StateJS.PseudoState('_initial', this._statemachine, StateJS.PseudoStateKind.Initial);
  const Html5Video_null_Idle = new StateJS.State('Idle', this._statemachine);
  const Html5Video_null_Initialize = new StateJS.State('Initialize', this._statemachine).entry(() => {
    this.clear();
    if (this.Html5Video_null_needsFullReset_var) {
      this.detachVideo();
    }
    this.Html5Video_null_Initialize_startedAt_var = this.timestamp();
    this.createNewVideo(this.Html5Video_null_Initialize_startedAt_var);
    this.attachVideo();
    this.bus.emit('html5VideoElement', new Event.VideoElement_Html5VideoElementMsg(this.name, 'html5VideoElement', this.Html5Video_video_var));
  });
  const Html5Video_null_Operating = new StateJS.State('Operating', this._statemachine).entry(() => {
    this.play();
  }).exit(() => {
    this.bus.emit('video', new Event.Ended_Html5VideoMsg(this.name, 'video'));
  });
  const Html5Video_null_Clear = new StateJS.State('Clear', this._statemachine).entry(() => {
    this.clear();
  });
  const Html5Video_null_Reset = new StateJS.State('Reset', this._statemachine).entry(() => {
    this.clear();
    this.detachVideo();
  });
  _initial_Html5Video.to(Html5Video_null_Idle);
  Html5Video_null_Reset.to(Html5Video_null_Idle);
  Html5Video_null_Initialize.to(Html5Video_null_Operating);
  this._statemachine.on(Event.Mute).when((mute) => mute.port === 'video' && mute.type === 'mute').effect((mute) => {
    this.Html5Video_userWantsSound_var = !(mute.status);
    this.mute();
    this.persistSoundsSettings(this.Html5Video_userWantsSound_var);
  });
  Html5Video_null_Operating.on(Event.Play).when((play) => play.port === 'video' && play.type === 'play').effect((play) => {
    this.play();
  });
  Html5Video_null_Clear.to(Html5Video_null_Operating).on(Event.Play_Html5VideoMsg).when((play) => play.port === 'video' && play.type === 'play');
  Html5Video_null_Idle.to(Html5Video_null_Initialize).on(Event.Play_Html5VideoMsg).when((play) => play.port === 'video' && play.type === 'play');
  Html5Video_null_Operating.to(Html5Video_null_Reset).on(Event.Clear_Html5VideoMsg).when((clear) => clear.port === 'video' && clear.type === 'clear' && (this.Html5Video_null_needsFullReset_var));
  Html5Video_null_Operating.to(Html5Video_null_Clear).on(Event.Clear_Html5VideoMsg).when((clear) => clear.port === 'video' && clear.type === 'clear' && (!(this.Html5Video_null_needsFullReset_var)));
};
Html5Video.prototype.isInternetExplorer = function () {
  return (typeof window.document.documentMode === 'number');
};

Html5Video.prototype.timestamp = function () {
  return Date.now();
};

Html5Video.prototype.onRatioChange = function (Html5Video_onRatioChange_ratio_var) {};

Html5Video.prototype.loadUserWantsSound = function () {
  const key_var = this.computeSoundSettingsPersistenceKey();
  if (!(this.Html5Video_tokenMode_var)) {
    try {
      return (window.localStorage.getItem(key_var) === 'true');
    } catch (error) {
      return this.Html5Video_userWantsSound_var;
    }
  }
  return this.Html5Video_userWantsSound_var;
};

Html5Video.prototype.persistSoundsSettings = function (Html5Video_persistSoundsSettings_userWantsSound_var) {
  if (!(this.Html5Video_tokenMode_var)) {
    const key_var = this.computeSoundSettingsPersistenceKey();
    try {
      if (Html5Video_persistSoundsSettings_userWantsSound_var) {
        window.localStorage.setItem(key_var, 'true');
      } else {
        window.localStorage.removeItem(key_var);
      }
    } catch (error) {}
  }
};

Html5Video.prototype.computeRatio = function () {
  if ((this.Html5Video_video_var != null)) {
    const width_var = (this.Html5Video_video_var.videoWidth);
    const height_var = (this.Html5Video_video_var.videoHeight);
    const ratio_var = width_var / height_var;
    if (this.Html5Video_currentRatio_var !== ratio_var) {
      this.onRatioChange(ratio_var);
      this.Html5Video_currentRatio_var = ratio_var;
    }
  }
};

Html5Video.prototype.createNewVideo = function (Html5Video_createNewVideo_startedAt_var) {
  this.Html5Video_metricsSent_var = false;
  this.Html5Video_waiting_var = false;
  this.bus.emit('statusInput', new Event.Waiting_StatusMsg(this.name, 'statusInput', false));
  this.Html5Video_video_var = document.createElement('video');
  this.Html5Video_video_var.setAttribute('poster', 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEAAAAALAAAAAABAAEAAAIA');
  if ('ManagedMediaSource' in window) {
    this.Html5Video_video_var.setAttribute('autoplay', '');
    this.Html5Video_video_var.setAttribute('playsinline', '');
  }
  this.Html5Video_video_var.addEventListener('playing', () => {
    this.computeRatio();
    this.bus.emit('video', new Event.Playing_Html5VideoMsg(this.name, 'video'));
    this.Html5Video_client_var.streamStatusCallback('video-playing');
    this.bus.emit('video', new Event.Sound_Html5VideoMsg(this.name, 'video', (!!this.Html5Video_video_var.mozHasAudio
        || !!this.Html5Video_video_var.webkitAudioDecodedByteCount
        || !!(this.Html5Video_video_var.audioTracks && this.Html5Video_video_var.audioTracks.length > 0))));
    if (!(this.Html5Video_metricsSent_var)) {
      this.bus.emit('statusInput', new Event.Duration_StatusMsg(this.name, 'statusInput', Enum.DurationTypes_ENUM.HTML5VIDEOSETUP, this.timestamp() - Html5Video_createNewVideo_startedAt_var));
    }
    this.Html5Video_metricsSent_var = true;
    if (this.Html5Video_waiting_var) {
      this.Html5Video_waiting_var = false;
      const waitingTime_var = this.timestamp() - this.Html5Video_waitingSince_var;
      this.bus.emit('waiting', new Event.Waiting_WaitingWatcherMsg(this.name, 'waiting', waitingTime_var));
      this.bus.emit('statusInput', new Event.Waiting_StatusMsg(this.name, 'statusInput', false));
    }
  });
  this.Html5Video_video_var.addEventListener('ended', () => {
    this.bus.emit('video', new Event.Ended_Html5VideoMsg(this.name, 'video'));
  });
  this.Html5Video_video_var.addEventListener('waiting', () => {
    if (!(this.Html5Video_waiting_var)) {
      this.Html5Video_waiting_var = true;
      this.Html5Video_waitingSince_var = this.timestamp();
      this.bus.emit('statusInput', new Event.Waiting_StatusMsg(this.name, 'statusInput', true));
    }
  });
  this.Html5Video_video_var.addEventListener('suspend', () => {
    if (!(this.Html5Video_waiting_var)) {
      this.Html5Video_waiting_var = true;
      this.Html5Video_waitingSince_var = this.timestamp();
      this.bus.emit('statusInput', new Event.Waiting_StatusMsg(this.name, 'statusInput', true));
    }
  });
  this.Html5Video_video_var.addEventListener('abort', () => {
    this.bus.emit('video', new Event.MediaError_Html5VideoMsg(this.name, 'video', Enum.MediaErrors_ENUM.ABORTED));
  });
  this.Html5Video_video_var.addEventListener('stalled', () => {
    this.bus.emit('video', new Event.Stalled_Html5VideoMsg(this.name, 'video'));
  });
  this.Html5Video_video_var.addEventListener('error', (e) => {
    this.Html5Video_client_var.logException(e);
    try {
      switch (e.code) {
        case MediaError.MEDIA_ERR_ABORTED:
          this.bus.emit('video', new Event.MediaError_Html5VideoMsg(this.name, 'video', Enum.MediaErrors_ENUM.ABORTED));
          break;
        case MediaError.MEDIA_ERR_NETWORK:
          this.bus.emit('video', new Event.MediaError_Html5VideoMsg(this.name, 'video', Enum.MediaErrors_ENUM.NETWORK));
          break;
        case MediaError.MEDIA_ERR_DECODE:
          this.bus.emit('video', new Event.MediaError_Html5VideoMsg(this.name, 'video', Enum.MediaErrors_ENUM.DECODE));
          break;
        case MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED:
          this.bus.emit('video', new Event.MediaError_Html5VideoMsg(this.name, 'video', Enum.MediaErrors_ENUM.UNSUPPORTED));
          break;
        default:
          this.bus.emit('video', new Event.MediaError_Html5VideoMsg(this.name, 'video', Enum.MediaErrors_ENUM.UNKNOWN));
          break;
      }
    } catch (error) {
      this.bus.emit('video', new Event.MediaError_Html5VideoMsg(this.name, 'video', Enum.MediaErrors_ENUM.UNKNOWN));
    }
  });
  this.Html5Video_video_var.addEventListener('volumechange', () => {
    this.bus.emit('video', new Event.Muted_Html5VideoMsg(this.name, 'video', (!!this.Html5Video_video_var.muted)));
  });
  return this.Html5Video_video_var;
};

Html5Video.prototype.attachVideo = function () {
  let container;
  if (this.Html5Video_videoContainerId_var !== undefined) {
    container = document.getElementById(this.Html5Video_videoContainerId_var);
  } else if (this.Html5Video_videoContainer_var !== undefined) {
    container = this.Html5Video_videoContainer_var;
  } else {
    container = document.body;
  }
  if (container) {
    container.appendChild(this.Html5Video_video_var);
  } else {
    this.bus.emit('video', new Event.PlayRejected_Html5VideoMsg(this.name, 'video'));
    this.Html5Video_client_var.logMessage('No container for video player');
  }
};

Html5Video.prototype.detachVideo = function () {
  if (this.Html5Video_video_var && typeof this.Html5Video_video_var.remove === 'function') {
    this.Html5Video_video_var.remove();
  } else if (this.Html5Video_video_var && this.Html5Video_video_var.parentNode) {
    this.Html5Video_video_var.parentNode.removeChild(this.Html5Video_video_var);
  }
  this.Html5Video_video_var = null;
};

Html5Video.prototype.play = function () {
  this.Html5Video_userWantsSound_var = this.loadUserWantsSound();
  this.mute();
  if (!('ManagedMediaSource' in window)) {
    if (this.isInternetExplorer()) {
      this.Html5Video_video_var.play();
    } else {
      this.Html5Video_video_var.play().catch((error) => {
        this.Html5Video_client_var.logException(error);
        this.bus.emit('video', new Event.PlayRejected_Html5VideoMsg(this.name, 'video'));
      });
    }
  }
};

Html5Video.prototype.mute = function () {
  if ((this.Html5Video_video_var != null)) {
    this.Html5Video_video_var.muted = !(this.Html5Video_userWantsSound_var);
  }
  this.bus.emit('video', new Event.Muted_Html5VideoMsg(this.name, 'video', !(this.Html5Video_userWantsSound_var)));
};

Html5Video.prototype.clear = function () {
  if (this.Html5Video_video_var) {
    this.Html5Video_video_var.removeAttribute('src');
    const loadPromise = this.Html5Video_video_var.load();
    if (loadPromise) {
      loadPromise.catch(() => {});
    }
  }
};

Html5Video.prototype.computeSoundSettingsPersistenceKey = function () {
  if ((!this.Html5Video_cameraId_var)) {
    return '';
  }
  return `sound-settings-${window.btoa(this.Html5Video_cameraId_var)}`;
};

Html5Video.prototype._stop = function () {
  this.root = null;
  this.ready = false;
  this.stopped = true;
};

Html5Video.prototype._delete = function () {
  this._statemachine = null;
  this._null_instance = null;
  this.bus.removeAllListeners();
};

Html5Video.prototype._init = function () {
  this._null_instance = new StateJS.Instance('null_instance', this._statemachine);
  this.ready = true;
};

Html5Video.prototype._receive = function (msg) {
  if (this.ready) {
    this._null_instance.evaluate(msg);
  } else if (!this.stopped) {
    setTimeout(() => this._receive(msg), 4);
  }
};

Html5Video.prototype.toString = function () {
  let result = `instance ${this.name}:${this.constructor.name}\n`;
  result += `\n\tstartedAt = ${this.Html5Video_null_Initialize_startedAt_var}`;
  result += `\n\tmetricsSent = ${this.Html5Video_metricsSent_var}`;
  result += `\n\twaitingSince = ${this.Html5Video_waitingSince_var}`;
  result += `\n\tneedsFullReset = ${this.Html5Video_null_needsFullReset_var}`;
  result += `\n\tvideoContainer = ${this.Html5Video_videoContainer_var}`;
  result += `\n\tcurrentRatio = ${this.Html5Video_currentRatio_var}`;
  result += `\n\tuserWantsSound = ${this.Html5Video_userWantsSound_var}`;
  result += `\n\twaiting = ${this.Html5Video_waiting_var}`;
  result += `\n\tvideoContainerId = ${this.Html5Video_videoContainerId_var}`;
  result += `\n\tvideo = ${this.Html5Video_video_var}`;
  result += `\n\ttokenMode = ${this.Html5Video_tokenMode_var}`;
  result += `\n\tclient = ${this.Html5Video_client_var}`;
  result += `\n\tcameraId = ${this.Html5Video_cameraId_var}`;
  result += '';
  return result;
};

module.exports = Html5Video;
